import { useEffect } from 'react';

/**
 * A component that actively monitors and fixes Radix UI's pointer-events blocking.
 * Radix UI's DismissableLayer sets document.body.style.pointerEvents = "none" when modals open,
 * which can cause UI elements to become unclickable. This component uses a MutationObserver
 * to detect and immediately reverse this behavior.
 */
export function PointerEventsGuard() {
  useEffect(() => {
    // Create a MutationObserver to detect when body style changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'style') {
          const body = document.body;
          if (body.style.pointerEvents === 'none') {
            body.style.pointerEvents = 'auto';
          }
        }
      });
    });

    observer.observe(document.body, { 
      attributes: true, 
      attributeFilter: ['style'] 
    });

    // Also check immediately on mount
    if (document.body.style.pointerEvents === 'none') {
      document.body.style.pointerEvents = 'auto';
    }

    return () => observer.disconnect();
  }, []);

  return null;
}
